import React from "react";
import tablestyles from "../../../components/Table/Table.module.sass";

const userEnum = {
	admin: "Super admin",
	brandAdmin: "Brand admin",
	brandOperator: "Marketplace operator",
};

const Row = ({ data }) => {
	const date = new Date(data.createdAt);
	return (
		<div className={tablestyles.row}>
			<div className={tablestyles.col}></div>
			<div className={tablestyles.col}>{data.from}</div>
			<div className={tablestyles.col}>{data.to}</div>
			<div className={tablestyles.col}>{userEnum[data.role]}</div>
			<div className={tablestyles.col}>Invited</div>
			<div className={tablestyles.col}>{date.toLocaleString()}</div>
		</div>
	);
};

export default Row;
